import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslocoService } from "@jsverse/transloco";

export class PaginatorI18n {
  constructor(private readonly translate: TranslocoService) {}

  getPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = this.translate.translate("grid.ITEMS_PER_PAGE_LABEL");
    paginatorIntl.nextPageLabel = this.translate.translate("grid.NEXT_PAGE_LABEL");
    paginatorIntl.previousPageLabel = this.translate.translate("grid.PREVIOUS_PAGE_LABEL");
    paginatorIntl.firstPageLabel = this.translate.translate("grid.FIRST_PAGE_LABEL");
    paginatorIntl.lastPageLabel = this.translate.translate("grid.LAST_PAGE_LABEL");
    paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);

    return paginatorIntl;
  }

  private getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return this.translate.translate("grid.RANGE_PAGE_LABEL_1", { length });
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return (
      startIndex +
      " " +
      this.translate.translate("grid.RANGE_PAGE_LABEL_1") +
      " " +
      endIndex +
      " " +
      this.translate.translate("grid.RANGE_PAGE_LABEL_2") +
      " " +
      length
    );
  }
}
